<template>
  <ClientChip
    :client-relation-id="column.id"
    :data-test="`agency-client-name-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import ClientChip from '@/components/Clients/ClientChip.vue'

// Spreads the chip's fragment so the row query warms the cache the chip reads from.
const StaffingAgencyClientNameColumn = graphql(`
  fragment StaffingAgencyClientNameColumn on SupplierClient {
    id
    # The export reads the name; the chip's own fields are masked from this fragment.
    client {
      id
      name
    }
    ...ClientChip
  }
`)

const props = defineProps<{
  row: FragmentType<typeof StaffingAgencyClientNameColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(StaffingAgencyClientNameColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
